import axios from 'axios';
import { Fragment, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../Context/AuthContext';

const BoardDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { decodeS1 } = useAuth();

  // URL 파라미터
  let { idx, cate } = useParams();

  // 리스트에서 넘어온 데이터 (없을 수도 있음)
  const { menuData, list } = location.state || {};

  const [data, setdata] = useState('');
  const [select, setSelect] = useState(0); // 상단 드롭다운
  const [pageTitle, setPageTitle] = useState(''); // 한글 제목

  // 🔹 현재 페이지 리스트 (이전글/다음글 계산용)
  const [listData, setListData] = useState(list || []);

  useEffect(() => {
    setListData(list || []);
  }, [list]);

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  useEffect(() => {
    getDetail();
  }, [cate, idx]);

  useEffect(() => {
    if (!cate) return;

    switch (cate) {
      case 'notice':
        setPageTitle('공지사항');
        break;
      case 'business':
        setPageTitle('사업공고');
        break;
      case 'education':
        setPageTitle('교육공고');
        break;
      case 'employment':
        setPageTitle('채용공고');
        break;
      case 'bid':
        setPageTitle('입찰공고');
        break;
      case 'news':
        setPageTitle('보도자료');
        break;
      case 'reference':
        setPageTitle('자료실');
        break;
      case 'archive':
        setPageTitle('융합원 아카이브');
        break;
      default:
        setPageTitle('');
        break;
    }
  }, [cate]);

  const handleSelect = (num) => {
    setSelect((prev) => (prev === num ? 0 : num));
  };

  const getDetail = () => {
    axios
      .get(`https://ciuc.or.kr:8443/api/get/board_detail?cate=${cate}&idx=${idx}`)
      .then((response) => {
        const data = response.data[0];
        setdata(data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  function formatDate(isoString) {
    if (!isoString) return '';
    const date = new Date(isoString);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    return `${year}-${month}-${day} `;
  }

  const handleDownload = (fileName) => {
    const link = document.createElement('a');
    window.open(`https://ciuc.or.kr:8443/api/download/${fileName}`, '_blank');
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // ---------- 상세 정보 getter ----------
  const getTitle = () => {
    if (menuData && menuData.title) return menuData.title;
    if (data && data.title) return data.title;
    return '';
  };

  const getWriter = () => {
    if (menuData && menuData.writer) return menuData.writer;
    if (data && data.writer) return data.writer;
    return '';
  };

  const getDate = () => {
    if (menuData && menuData.date) return menuData.date;
    if (data && data.date) return data.date;
    return '';
  };

  const getHit = () => {
    if (menuData && menuData.hit) return menuData.hit;
    if (data && data.hit) return data.hit;
    return '';
  };

  const getContent = () => {
    if (menuData && menuData.content) return menuData.content;
    if (data && data.content) return data.content;
    return '';
  };

  const getAttachmentCount = () => {
    let count = 0;
    for (let i = 1; i <= 5; i++) {
      if (menuData && menuData[`img${i}`]) {
        count++;
      } else if (data && data[`img${i}`]) {
        count++;
      }
    }
    return count;
  };

  const getImg = () => {
    const images = [];
    for (let i = 1; i <= 5; i++) {
      if (menuData && menuData[`img${i}`]) {
        images.push(menuData[`img${i}`]);
      } else if (data && data[`img${i}`]) {
        images.push(data[`img${i}`]);
      }
    }
    return images;
  };

  // ---------- 리스트 안에서 이전글/다음글 찾기 ----------
  const findAdjacentInList = (targetIdx) => {
    if (!listData || listData.length === 0) {
      return { prev: null, next: null };
    }

    const idxNumber = Number(targetIdx);
    const index = listData.findIndex((item) => Number(item.idx) === idxNumber);

    if (index === -1) {
      return { prev: null, next: null };
    }

    // 🔹 리스트가 idx 내림차순(최신이 0번)이라고 가정
    const prev = index < listData.length - 1 ? listData[index + 1] : null; // 아래에 있는 글
    const next = index > 0 ? listData[index - 1] : null; // 위에 있는 글

    return { prev, next };
  };

  const { prev: prevPost, next: nextPost } = findAdjacentInList(idx);

  // ---------- 이동 & 버튼 ----------
  const moveBoard = (cateTarget) => {
    navigate(`/board/${cateTarget}`, { state: { cate: cateTarget } });
  };

  const movePage = (path) => {
    navigate(path);
  };

  const boardEdit = () => {
    navigate(`/board/${cate}/modify`, {
      state: {
        menuData: menuData || {},
        data: data || {},
        img1: menuData?.img1 || data?.img1,
        img2: menuData?.img2 || data?.img2,
        img3: menuData?.img3 || data?.img3,
        img4: menuData?.img4 || data?.img4,
        img5: menuData?.img5 || data?.img5,
      },
    });
  };

  const boardDel = async () => {
    const confirmDelete = window.confirm(`해당 게시글을 삭제하시겠습니까?`);
    if (!confirmDelete) return;

    const targetIdx = menuData?.idx || data?.idx || idx;

    try {
      await axios.post('https://ciuc.or.kr:8443/api/post/board_delete', {
        idx: targetIdx,
        cate: cate,
      });
      alert('게시글이 삭제되었습니다.');
      navigate(`/board/${cate}`, { state: { cate: cate } });
    } catch (error) {
      console.error('Error fetching list:', error);
    }
  };

  const handlePrevPost = () => {
    if (!prevPost) {
      alert('이전 글이 없습니다.');
      return;
    }
    navigate(`/board/${cate}/${prevPost.idx}`, {
      state: {
        menuData: prevPost,
        cate,
        list: listData, // 리스트 다시 넘겨줘야 다음/이전 계산 가능
      },
    });
  };

  const handleNextPost = () => {
    if (!nextPost) {
      alert('다음 글이 없습니다.');
      return;
    }
    navigate(`/board/${cate}/${nextPost.idx}`, {
      state: {
        menuData: nextPost,
        cate,
        list: listData,
      },
    });
  };

  return (
    <div className="sub_wrap">
      <div className="sub_back">
        {/* 상단 배너 */}
        <div className="sub_banner_area notice">
          <div className="sub_banner_back">
            <div className="navi_text">
              <div className="home_icon_sub"></div>
              {'> '}알림 및 소식{' > '}
              {pageTitle}
            </div>
            <div className="banner_main_text">{pageTitle}</div>
          </div>
        </div>

        {/* 상단 네비 (드롭다운 2개) */}
        <div className="navi_area">
          <div className="navi_back_wrap">
            <div className="navi_back">
              {/* 1. 대분류 셀렉트 */}
              <div className="navi_box" onClick={() => handleSelect(1)}>
                <div className="navi_main_text">알림 및 소식</div>
                <div className="navi_arrow"></div>
                <div className={`navi_select_box ${select === 1 && 'active'}`}>
                  <div className="select_row" onClick={() => moveBoard('notice')}>
                    알림 및 소식
                  </div>
                  <div className="select_row" onClick={() => movePage('/fusionSupportProgram')}>
                    사업분야
                  </div>
                  <div className="select_row" onClick={() => movePage('/inquiryinfo')}>
                    기업연구동
                  </div>
                  <div className="select_row" onClick={() => movePage('/meetingroom')}>
                    보유시설
                  </div>
                  <div className="select_row" onClick={() => movePage('/vision')}>
                    융합원소개
                  </div>
                </div>
              </div>

              {/* 2. 소분류 셀렉트 */}
              <div className="navi_box" onClick={() => handleSelect(2)}>
                <div className="navi_main_text">{pageTitle}</div>
                <div className="navi_arrow"></div>
                <div className={`navi_select_box ${select === 2 && 'active'}`}>
                  <div className="select_row" onClick={() => moveBoard('notice')}>
                    공지사항
                  </div>
                  <div className="select_row" onClick={() => moveBoard('business')}>
                    사업공고
                  </div>
                  <div className="select_row" onClick={() => moveBoard('education')}>
                    교육공고
                  </div>
                  <div className="select_row" onClick={() => moveBoard('employment')}>
                    채용공고
                  </div>
                  <div className="select_row" onClick={() => moveBoard('bid')}>
                    입찰공고
                  </div>
                  <div className="select_row" onClick={() => moveBoard('news')}>
                    보도자료
                  </div>
                  <div className="select_row" onClick={() => moveBoard('reference')}>
                    자료실
                  </div>
                  <div className="select_row" onClick={() => moveBoard('archive')}>
                    융합원 아카이브
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 본문 영역 */}
        <div className="sub_main_area board">
          {/* 고정 사이드바 */}
          <aside className="intro_aside_fixed">
            <div className="intro_aside_header">알림 및 소식</div>
            <ul className="intro_aside_list">
              <li className={`intro_aside_item ${isActive('/board/notice')}`} onClick={() => moveBoard('notice')}>
                <span>공지사항</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/board/business')}`} onClick={() => moveBoard('business')}>
                <span>사업공고</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/board/education')}`} onClick={() => moveBoard('education')}>
                <span>교육공고</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li
                className={`intro_aside_item ${isActive('/board/employment')}`}
                onClick={() => moveBoard('employment')}
              >
                <span>채용공고</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/board/bid')}`} onClick={() => moveBoard('bid')}>
                <span>입찰공고</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/board/news')}`} onClick={() => moveBoard('news')}>
                <span>보도자료</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/board/reference')}`} onClick={() => moveBoard('reference')}>
                <span>자료실</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/board/archive')}`} onClick={() => moveBoard('archive')}>
                <span>융합원 아카이브</span>
                <span className="aside_arrow">&gt;</span>
              </li>
            </ul>
          </aside>

          {/* 오른쪽 상세 내용 영역 */}
          <div className="board_container-sub">
            {/* 제목 + 현재 경로 */}
            <div className="board_path_box">
              <div className="path_title">{pageTitle}</div>
              <div className="path_navi">
                <span className="home_icon_small">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
                    <path d="M4 11.5L12 4l8 7.5V20a1 1 0 0 1-1 1h-5v-5h-4v5H5a1 1 0 0 1-1-1v-8.5z" fill="#999999" />
                    <path
                      d="M2.5 12L12 3l9.5 9"
                      fill="none"
                      stroke="#cccccc"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                <span className="path_arrow">&gt;</span>
                <span>알림마당</span>
                <span className="path_arrow">&gt;</span>
                <span className="current">{pageTitle}</span>
              </div>
            </div>

            {/* detail_wrap */}
            <div className="detail_wrap">
              <div className="detail_back">
                {getTitle() && (
                  <div className="detail_top_box">
                    <div className="detail_title">{getTitle()}</div>
                    <div className="title_sub_box">
                      <div className="sub_row">
                        <div className="sub_title">작성자</div>
                        <div className="sub_text">{getWriter()}</div>
                      </div>
                      <div className="sub_row">
                        <div className="sub_title">작성일</div>
                        <div className="sub_text">{getDate() ? formatDate(getDate()) : ''}</div>
                      </div>
                      <div className="sub_row">
                        <div className="sub_title">조회수</div>
                        <div className="sub_text">{getHit()}</div>
                      </div>
                    </div>
                  </div>
                )}

                <div
                  className="contents_text_bbs"
                  dangerouslySetInnerHTML={{
                    __html: getContent(),
                  }}
                ></div>

                <div className="detail_file_box">
                  <div className="file_title">
                    첨부파일 <span>{getAttachmentCount()}</span>
                  </div>
                  <div className="file_contents_box">
                    {getImg().length > 0 ? (
                      getImg().map((img, index) => (
                        <div
                          className="file_row"
                          key={index}
                          onClick={(event) => handleDownload(event.target.textContent)}
                        >
                          <div className="file_icon"></div>
                          <div className="file_text">{img}</div>
                        </div>
                      ))
                    ) : (
                      <div className="file_row">
                        <div className="file_text" style={{ paddingRight: '10px' }}>
                          첨부파일이 존재하지 않습니다.
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* 하단 버튼 영역 */}
                <div className="detail_btn_box">
                  {/* 왼쪽 : 이전글 / 다음글 */}
                  <div className="detail_btn_group left">
                    <div className={`detail_btn short ${!prevPost ? 'is-disabled' : ''}`} onClick={handlePrevPost}>
                      {'<'}&nbsp;이전글
                    </div>
                    <div className={`detail_btn short ${!nextPost ? 'is-disabled' : ''}`} onClick={handleNextPost}>
                      다음글&nbsp;{'>'}
                    </div>
                  </div>

                  {/* 오른쪽 : 목록으로 + (관리자) 수정/삭제 */}
                  <div className="detail_btn_group right">
                    <div className="detail_btn color" onClick={() => navigate(`/board/${cate}`, { state: { cate } })}>
                      목록으로
                    </div>
                    {decodeS1() === 'admin' && (
                      <Fragment>
                        <div className="detail_btn short" onClick={boardEdit}>
                          수정
                        </div>
                        <div className="detail_btn short" onClick={boardDel}>
                          삭제
                        </div>
                      </Fragment>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* detail_wrap 끝 */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BoardDetail;
